<template>
  <div class="fts-collapsible-element">
    <slot 
      name="toggle" 
      :toggle="toggle" 
      :isVisible="isVisible" 
      v-if="immersive ? !isVisible : true">
      <div 
        class="collapsible-element-toggle" 
        :class="[{'toggle-mb': !immersive && isVisible}, toggleClass]" 
        @click="toggle">
        <slot name="toggle-text" :isVisible="isVisible">
          click to {{isVisible ? 'disable' : 'enable'}} {{label}} 
        </slot>
        <div v-if="beta">
          &nbsp;
          <fts-release-badge class="fts-align-top" />
        </div>
      </div>
    </slot>
    <slot name="content" :isVisible="isVisible" v-if="isVisible">
      Default Content
    </slot>
  </div>
</template>

<script>
import FTSReleaseBadge from "./FTSReleaseBadge";

export default {
  props: {
    initialVisible: Boolean,
    condition: {
      required: false
    },
    toggleClass: String,
    immersive: Boolean,
    label: {
      type: String,
      default: 'element'
    },
    beta: Boolean
  },
  components: {
    "fts-release-badge": FTSReleaseBadge,
  },
  model: {
    prop: "condition",
    event: "updateCondition"
  },
  data: () => ({
    isVisible: false,
  }),
  methods: {
    toggle() {
      this.isVisible = !this.isVisible;
      this.$emit('updateCondition', this.isVisible);
    }
  },
  watch: {
    condition: {
      immediate: true,
      handler(val, oldVal) {
        if (!this.immersive || (this.immersive && !oldVal))
          this.isVisible = !!val;
      }
    }
  },
  mounted() {
    if (this.initialVisible) 
      this.isVisible = true;
  },
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-collapsible-element {
  .collapsible-element-toggle {
    display: inline-flex;
    color: var(--fts-gray-5);
    font-size: .875rem;
    font-weight: 300;
    &:hover {
      color: $primaryColor;
      cursor: pointer;
    }
    &.toggle-mb {
      margin-bottom: .75rem;
    }
  }
}
</style>